export default __webpack_public_path__ + "static/media/mystical-eyes-dark.75144478.jpg";